import double_room_preview from './double_room_preview.jpg'
import double_room from './double_room.jpg'

export { double_room_preview, double_room }



// WEBPACK FOOTER //
// ./src/features/Hotel/components/DoubleRoom/images/index.js